import { ModelHelper } from '@dentsply-sirona/utilities';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OrderState } from '../enums/order-state.enum';
import { Order } from '../models/order.model';
import { WhereFilter } from '../models/where-filter.model';
import { OrderSchema } from '../schemas/order.schema';
import { GraphqlService } from './graphql.service';
import { SortDirection } from '../enums/sort-direction.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class OrderService extends GraphqlService {
	/**
	 * Order-Liste laden
	 *
	 * @param filters Filter
	 * @param pageIndex Index der ersten Seite
	 * @param resultsPerPage Anzahl an Ergebnissen pro Seite
	 * @param orderBy Sortierung
	 * @param sortDirection Sortierreihenfolge
	 */
	getOrderList(
		filters: WhereFilter[] = [],
		pageIndex: number = 0,
		resultsPerPage: number = 10,
		orderBy?: string,
		sortDirection?: string
	): Observable<{ totalCount: number; list: Order[] }> {
		let isAscending = null;
		if (sortDirection === SortDirection.ASCENDING) {
			isAscending = 'true';
		} else if (sortDirection === SortDirection.DESCENDING) {
			isAscending = 'false';
		}

		return this.query(OrderSchema.getOrderList, {
			filters,
			pageIndex,
			resultsPerPage,
			orderBy,
			isAscending
		}).pipe(
			map((data: any) => ({
				totalCount: data.orderlist.totalCount,
				list: ModelHelper.mapArray<Order>(Order, data.orderlist.list)
			}))
		);
	}

	/**
	 * Update order state
	 */
	updateOrderState(orderState: OrderState, externalUid: string, comment?: string): Observable<Order> {
		return this.mutation(OrderSchema.updateOrderState, {
			input: orderState,
			externalOrderUid: externalUid,
			comment
		}).pipe(map((response: any) => Order.map(response.updateOrderState)));
	}
}
